/**
 * @author XG AND TYH
 * @date 2019/12/25
 * @Description: app广告稿件
 */
'use strict';
angular.module('editingCenterAppAdvertisementModule', []).controller('editingCenterAppAdvertisementController', [
    '$scope',
    '$state',
    '$q',
    '$filter',
    '$element',
    '$compile',
    'trsHttpService',
    'messagePublishService',
    'jsonArrayToStringService',
    'editingCenterService',
    '$validation',
    'appConst',
    'editingCenterAppService',
    'globleParamsSet',
    'editIsLock',
    'localStorageService',
    function(
        $scope,
        $state,
        $q,
        $filter,
        $element,
        $compile,
        trsHttpService,
        messagePublishService,
        jsonArrayToStringService,
        editingCenterService,
        $validation,
        appConst,
        editingCenterAppService,
        globleParamsSet,
        editIsLock,
        localStorageService
    ) {
        initStatus();
        initData();
        editingCenterAppService.addFuture($scope, ['sendmessage']);
        /**
         * [initStatus description]初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.parentStatus = {
                switch: 'manuscriptInfo', // 稿件信息和流程版本切换，默认稿件信息
                mediaName: 'appAd', // 稿件类型
                noNeedGetKeywordsOrAbstract: true, // 不需要抽取关键词与摘要
                trench: 'app', // 当前渠道名
                position: $state.params.appplatform,
            };
            $scope.parentData = {
                formName: 'advertisementForm', // 表单名称
                path: {
                    '1': 'editingCenterAppPersonalVersionTime',
                },
                versionName: {
                    '1': 'appobjectversionid',
                },
                selActList: [], // 选择活动已选的数据。
                ACTList: [], // 选择活动的数据,
                KEYWORDS: [],
            };
            $scope.status = {
                hasTitleSynced: false, // 标题是否已经同步给列表标题
            };
            // 存放的是向后台提交的数据和回写的数据
            $scope.list = angular.extend(
                {
                    methodName: 'saveAdDoc', // 执行保存操作时的方法
                    CHANNELID: $state.params.appchannelid,
                },
                appConst.list
            );
            $scope.element = $element;
            $scope.compile = $compile;
        }

        /**
         * [selDataChange description]下拉框点击选中事件
         *
         * @return  {[type]}  [return description]
         */
        $scope.selDataChange = function() {
            $scope.list.LISTSTYLE = $scope.parentData.selActList.LISTSTYLE ? $scope.parentData.selActList.LISTSTYLE : 0;
            $scope.list.LISTTITLE = $scope.parentData.selActList.LISTTITLE;
            $scope.list.LISTPICS = $scope.parentData.selActList.LISTPICS;
            if ($scope.parentData.selActList.LISTPICS[0].SRCPICURL) {
                angular.forEach($scope.parentData.selActList.LISTPICS, function(item) {
                    item.PERPICURL = item.SRCPICURL;
                    delete item.SRCPICURL;
                });
            }
            $scope.list.TITLE = $scope.parentData.selActList.TITLE;
            $scope.list.URL = $scope.parentData.selActList.URL;
        };

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            getAdvertisement();
            if ($state.params.appchnldocid) {
                initEditData();
            }
            emitCloseWindow();
        }

        /**
         * [showPreviewPic 点击显示预览图]
         * @return {[type]} [description]
         */
        $scope.showPreviewPic = function () {
            if ($scope.parentData.selActList.URL) {
                window.open($scope.parentData.selActList.URL);
            }
        };

        /**
         * [formatToStringTime 时间戳转换成 MM-dd HH:mm]
         * @param {[type]} timestamp [description]
         * @return {[type]} [description]
         */
        function formatToStringTime(timestamp) {
            let month, days, hours, minutes, result;
            timestamp = new Date(timestamp);
            month = timestamp.getMonth() + 1 < 10 ? '0' + (timestamp.getMonth() + 1) : timestamp.getMonth() + 1;
            days = timestamp.getDate() < 10 ? '0' + timestamp.getDate() : timestamp.getDate();
            hours = timestamp.getHours() < 10 ? '0' + timestamp.getHours() : timestamp.getHours();
            minutes = timestamp.getMinutes() < 10 ? '0' + timestamp.getMinutes() : timestamp.getMinutes();
            result = month + '-' + days + ' ' + hours + ':' + minutes;
            return result;
        }

        /**
         * [getTitleInfo 获取广告信息]
         * @return {[type]} [description]
         */
        function getAdvertisement() {
            editingCenterAppService.getActivityOrAdvertisement('getAdInfo').then((data) => {
                $scope.parentData.ACTList = globleParamsSet.dealDropDownData(data, 'TITLE', 'TITLE');
                angular.forEach($scope.parentData.ACTList, function(item) {
                    item.STARTTIME = formatToStringTime(parseInt(item.STARTTIME));
                });
                if ($scope.list.URL) {
                    let selectList = $filter('filterBy')($scope.parentData.ACTList, ['URL',], $scope.list.URL);
                    $scope.parentData.selActList = angular.copy(selectList[0]);
                }
            });
        }

        /**
         * [getOperaDoc 获取稿件信息]
         * @return {[type]} [description]
         */
        function initEditData() {
            let params = {
                methodName: 'getNewsDoc',
                serviceid: 'mlf_appmetadata',
                ChnlDocId: $state.params.appchnldocid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                $scope.list = data;
                $scope.list.serviceid = 'mlf_appmetadata'; // 执行保存操作时的方法
                $scope.list.methodName = 'saveAdDoc'; // 执行保存操作时的方法
                // 编辑时默认先跳到第一项
                // $scope.parentData.selActList = angular.copy($scope.parentData.ACTList[0]);
                document.title = $scope.parentData.selActList.TITLE = $scope.list.TITLE;
                messagePublishService.publish(`${$scope.parentStatus.mediaName}VersionInit`);
                messagePublishService.publish('hasGetEditInfo', true); // 表示已请求到数据 通知各子组件得到数据后处理数据
                syncTitleToListTitle();
            });
            editIsLock.lockDraft($state.params.appmetadataid); // 加锁操作
        }

        /**
         * [dealSaveUrlParams description] 保存时处理url上的参数以及其他参数
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        function dealSaveUrlParams(data) {
            if ($state.params.appchnldocid || $state.params.appmetadataid) {
                return;
            }
            $scope.list.CHNLDOCID = data.CHNLDOCID;
            $scope.list.METADATAID = data.METADATAID;
            $state.params.appchnldocid = data.CHNLDOCID;
            $state.params.appmetadataid = data.METADATAID;
            // $state.transitionTo($state.current, $state.params, {
            //     reload: false,
            // });
            // editIsLock.lockDraft($state.params.appmetadataid); // 加锁操作
        }

        /**
         * [getKeyWords description]获取关键词
         * @return {[type]} [description]
         */
        function getKeyWords() {
            $scope.list.KEYWORDS = '';
            angular.forEach($scope.parentData.KEYWORDS, function(data, index, array) {
                if (index !== $scope.parentData.KEYWORDS.length - 1) {
                    $scope.list.KEYWORDS += data.name + ';';
                } else {
                    $scope.list.KEYWORDS += data.name;
                }
            });
        }

        /**
         * [doSomeThingAfterSave description] 执行保存
         * @return  {[type]}  [return description]
         */
        $scope.doSave = function() {
            var deferred = $q.defer();
            getKeyWords();
            $validation.validate($scope.advertisementForm.authorForm);
            $scope.advertisementForm.$pending = {};
            $validation
                .validate($scope.advertisementForm)
                .success(function() {
                    messagePublishService.publish('packageParams', true); // 保存时通知各子组件组装参数
                    var list = angular.copy($scope.list);
                    list = jsonArrayToStringService.jsonArrayToString(list);
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'POST').then((data) => {
                        dealSaveUrlParams(data);
                        messagePublishService.publish(`${$scope.parentStatus.mediaName}VersionInit`);
                        deferred.resolve();
                    });
                })
                .error(function() {
                    editingCenterService.checkSaveError($scope.advertisementForm, $element, $scope); // 定位输入错的表单位置
                    deferred.reject();
                });
            return deferred.promise;
        };

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            editingCenterService.allAppCloseWindow($scope, {typeName: 'app', saveLocal: false, hascondition: false});
        }

        /**
         * [syncTitleToListTitle 将文章标题同步给列表标题]
         *
         * @return  {[type]}  [return description]
         */
        $scope.syncTitleToListTitle = function(){
            syncTitleToListTitle();
        };

        /**
         * [syncTitleToListTitle 将文章标题同步给列表标题实现]
         *
         * @return  {[type]}  [return description]
         */
        function syncTitleToListTitle(){
            if ($scope.status.hasTitleSynced){
                return;
            } else {
                if ($scope.list.LISTTITLE !== '') {
                    return;
                } else {
                    $scope.list.LISTTITLE = $scope.list.TITLE;
                    $scope.status.hasTitleSynced = true;
                }
            }
        }
    },
]);
